import { render, staticRenderFns } from "./Skit.vue?vue&type=template&id=bf680338&scoped=true&"
import script from "./Skit.vue?vue&type=script&lang=js&"
export * from "./Skit.vue?vue&type=script&lang=js&"
import style0 from "./Skit.vue?vue&type=style&index=0&id=bf680338&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf680338",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VSimpleTable})
